module.exports = __webpack_public_path__ + "img/lk.05027eb4.svg";